var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedInn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 36C28.165 36 36 28.165 36 18.5C36 8.83502 28.165 1 18.5 1C8.83502 1 1 8.83502 1 18.5C1 28.165 8.83502 36 18.5 36Z",
    stroke: "#274B89",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4837 14.9671C15.303 14.9671 15.9672 14.3029 15.9672 13.4835C15.9672 12.6642 15.303 12 14.4837 12C13.6643 12 13.0001 12.6642 13.0001 13.4835C13.0001 14.3029 13.6643 14.9671 14.4837 14.9671Z",
    fill: "#274B89"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7198 15.958H13.2473C13.1108 15.958 13 16.0688 13 16.2053V23.623C13 23.7595 13.1108 23.8703 13.2473 23.8703H15.7198C15.8563 23.8703 15.9671 23.7595 15.9671 23.623V16.2053C15.9671 16.0688 15.8563 15.958 15.7198 15.958Z",
    fill: "#274B89"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.088 15.5464C22.0313 15.1844 20.7094 15.5024 19.9167 16.0726C19.8895 15.9662 19.7926 15.8871 19.6774 15.8871H17.2048C17.0683 15.8871 16.9575 15.9979 16.9575 16.1344V23.5521C16.9575 23.6886 17.0683 23.7994 17.2048 23.7994H19.6774C19.8138 23.7994 19.9246 23.6886 19.9246 23.5521V18.2212C20.3242 17.8771 20.839 17.7673 21.2603 17.9463C21.6688 18.1189 21.9027 18.5402 21.9027 19.1015V23.5521C21.9027 23.6886 22.0135 23.7994 22.1499 23.7994H24.6225C24.759 23.7994 24.8698 23.6886 24.8698 23.5521V18.6035C24.8416 16.5715 23.8857 15.8194 23.088 15.5464Z",
    fill: "#274B89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInn);
export default __webpack_public_path__ + "static/media/LinkedInn.f769e816868ada71e909c0fbf307baad.svg";
export { ForwardRef as ReactComponent };